import {FileUpload, Button} from '@/components/atoms';
import PropTypes from 'prop-types';

/**
 * FileUploadWithTemplate component allows users to upload a file using a template and provides options to download the template and view the uploaded data in a table.
 *
 * @component
 * @param {Object} props - Component props
 * @param {string} [props.headerTitle='Upload Template'] - Title displayed at the top of the component
 * @param {boolean} props.uploadComplete - Flag indicating if the file upload is complete
 * @param {function} props.handleDownloadTemplate - Function to handle the download template button click
 * @param {string} [props.viewTableButtonText='View Data Table'] - Text for the view table button
 * @param {function} props.handleViewTable - Function to handle the view table button click
 * @param {string} [props.fileUploadLabel=''] - Label for the file upload field
 * @param {function} props.handleFileSelect - Function to handle file selection
 * @param {Array} props.files - Array of selected files
 * @returns {JSX.Element} The rendered component
 */
export default function FileUploadWithTemplate({
  headerTitle = 'Upload Template',
  uploadComplete,
  handleDownloadTemplate,
  viewTableButtonText = 'View Data Table',
  handleViewTable,
  fileUploadLabel = '',
  handleFileSelect,
  files
}) {
  return (
    <>
      <div className='mb-6 flex flex-row justify-between'>
        <h1 className='float-left h-8 max-w-[70%] text-2xl font-bold leading-8'>
          {headerTitle}
        </h1>
        <Button
          handleButton={handleDownloadTemplate}
          uiSchema={{
            title: 'Download Template',
            size: 'medium',
            variant: 'secondary'
          }}
        />
      </div>
      <div className='mb-6'>
        <FileUpload
          acceptedExtensions='.csv'
          description={'Drag and drop your file here'}
          label={fileUploadLabel}
          updateValue={handleFileSelect}
          value={files}
          multiple={false}
          className='!max-w-full'
          containerClassName='!w-full'
        />
      </div>
      {uploadComplete && (
        <div className='mb-6 flex flex-wrap py-2'>
          <Button
            handleButton={handleViewTable}
            uiSchema={{
              title: viewTableButtonText,
              size: 'medium',
              variant: 'primary'
            }}
          />
        </div>
      )}
    </>
  );
}

FileUploadWithTemplate.propTypes = {
  headerTitle: PropTypes.string,
  uploadComplete: PropTypes.bool.isRequired,
  handleDownloadTemplate: PropTypes.func.isRequired,
  viewTableButtonText: PropTypes.string,
  handleViewTable: PropTypes.func.isRequired,
  fileUploadLabel: PropTypes.string,
  handleFileSelect: PropTypes.func.isRequired,
  files: PropTypes.array.isRequired
};
